const LOGO_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_legal-studio-14/artifacts/ox5h9sri_0.png";

export const LogoMark = ({ className = "h-11" }) => (
  <img src={LOGO_IMG} alt="Legali@ Law Firm" className={`${className} w-auto rounded-[4px]`} />
);

export const Logo = ({ onNavigate }) => (
  <button
    data-testid="nav-logo"
    onClick={() => onNavigate && onNavigate("top")}
    className="group flex items-center"
    aria-label="Torna all'inizio"
  >
    <LogoMark className="h-11 transition-transform duration-500 group-hover:scale-[1.03]" />
  </button>
);
